import { createFileRoute } from "@tanstack/react-router";

import { ContributorsLibrary } from "@/components/admin/library-pages";

export const Route = createFileRoute("/admin/pupils")({
  component: ContributorsLibrary,
  head: () => ({ meta: [{ title: "Contributors" }] }),
});
